var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"console-ban"},[_c('h1',[_vm._v("如果您想继续浏览本站内容")]),_c('h1',[_vm._v("请关闭浏览器的\"开发者工具\"后点击")]),_c('a',{attrs:{"href":"/home"}},[_vm._v("回到本站首页")]),_c('h1',[_vm._v("谢谢您的配合")])])
}]

export { render, staticRenderFns }